"use client"

import CircularSlider from './CircularSlider';

export default CircularSlider;
